import React from "react";
import "./Hotel_application.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form } from "react-bootstrap";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Blue_btn from "../../../../../common_components/common_btn/blue_btn/Blue_btn";
function Hotel_application() {
  const navigate = useNavigate();

  return (
    <>
      <section className="Hotel_application">
        <div className="detail_header">
          <Button
            className="back_btn"
            onClick={() => navigate("/portal/hotel/intern")}
          >
            <div className="back_icon_holder">
              <FontAwesomeIcon icon={faAngleLeft} />
            </div>
            Back
          </Button>
        </div>

        <div className="card_box">
          <div className="form_holder">
            <Form>
              <div className="row">
                {/* Hotel Name */}
                <div className="col-md-6 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Hotel Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter hotel name" />
                  </Form.Group>
                </div>

                {/* Department / Position */}
                <div className="col-md-6 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Department / Position</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter department or position"
                    />
                  </Form.Group>
                </div>

                {/* Start Date */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control type="date" />
                  </Form.Group>
                </div>

                {/* End Date */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control type="date" />
                  </Form.Group>
                </div>

                {/* Working Hours */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Working Hours</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter working hours"
                    />
                  </Form.Group>
                </div>

                {/* Number of Vacancies */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Number of vacancies</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter No. of vacancies"
                    />
                  </Form.Group>
                </div>

                {/* Internship Description */}
                <div className="col-md-6 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Internship Description</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter internship description"
                    />
                  </Form.Group>
                </div>

                {/* Hotel Address */}
                <div className="col-md-6 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Hotel Address</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter hotel address"
                    />
                  </Form.Group>
                </div>

                {/* Salary / Stipend */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Salary / Stipend</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Salary / Stipend"
                    />
                  </Form.Group>
                </div>

                {/* Accommodation */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Accommodation</Form.Label>
                    <Select
                      options={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      placeholder="Select Yes / No"
                      classNamePrefix="react_select"
                    />
                  </Form.Group>
                </div>

                {/* Room Type */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Room Type</Form.Label>
                    <Select
                      options={[
                        { value: "shared", label: "Shared" },
                        { value: "single", label: "Single" },
                      ]}
                      placeholder="Select room type"
                      classNamePrefix="react_select"
                    />
                  </Form.Group>
                </div>

                {/* Meals Provided */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Meals Provided</Form.Label>
                    <Select
                      options={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      placeholder="Select Yes / No"
                      classNamePrefix="react_select"
                    />
                  </Form.Group>
                </div>

                {/* Uniform Provided */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Uniform provided</Form.Label>
                    <Select
                      options={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      placeholder="Select Yes / No"
                      classNamePrefix="react_select"
                    />
                  </Form.Group>
                </div>

                {/* Laundry Service */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Laundry service</Form.Label>
                    <Select
                      options={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      placeholder="Select Yes / No"
                      classNamePrefix="react_select"
                    />
                  </Form.Group>
                </div>

                {/* French Level */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>French level required</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter French level required"
                    />
                  </Form.Group>
                </div>

                {/* English Level */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>English level required</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter English level required"
                    />
                  </Form.Group>
                </div>

                {/* Document Required */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Document Required</Form.Label>
                    <Select
                      options={[
                        { value: "resume", label: "Resume" },
                        { value: "passport", label: "Passport" },
                        { value: "visa", label: "Visa" },
                      ]}
                      placeholder="Select required Doc."
                      classNamePrefix="react_select"
                    />
                  </Form.Group>
                </div>

                {/* Portfolio Required */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Portfolio required</Form.Label>
                    <Select
                      options={[
                        { value: "yes", label: "Yes" },
                        { value: "no", label: "No" },
                      ]}
                      placeholder="Select Yes / No"
                      classNamePrefix="react_select"
                    />
                  </Form.Group>
                </div>

                {/* Supervisor Name */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Supervisor / Mentor name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Supervisor / Mentor name"
                    />
                  </Form.Group>
                </div>

                {/* HR Email */}
                <div className="col-md-3 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>HR contact email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter HR contact email"
                    />
                  </Form.Group>
                </div>

                <div className="col-12 mt-4 text-center">
                  <Blue_btn btn_text="Submit" />
                </div>
              </div>
            </Form>
          </div>
        </div>
      </section>
    </>
  );
}

export default Hotel_application;
